import React,{useEffect,useState,createContext, lazy, Suspense} from 'react';
import {NavBar,SideBar,Overview,Settings,Applicants,Approvals,Payment,OldApplicants,Applications, Interview, TrainingInvites, InductionInvites, Reports} from './index';
import {Routes,Route,useNavigate} from 'react-router-dom';
import css from '../../css/dashboard.module.css';
import { FetchSingleData } from '../../hooks/FetchData';
import { setRole } from '../../redux/reducers/approvalReducer';
import { useDispatch } from 'react-redux';
import ProtectedRoute from '../../hooks/ProtectedRoute';
import { useSelector } from 'react-redux';
import { CircularProgress } from '@mui/material';

const LazyOverview = lazy(() => import('./Overview2'));
const LazyApplicants = lazy(() => import('./Applicants/Applicants'));
const LazySettings = lazy(() => import('./Settings/Settings'));
const LazyApprovals = lazy(() => import('./Approvals/Approve/Approvals'));
const LazyPayments = lazy(() => import('./Payment/Payment'));
const LazyUploadOffLine = lazy(() => import('./UploadOffLine/UploadOffLinePayment'));
const LazyApplications = lazy(() => import('./Applications/Applications'));
const LazyOldApplicants = lazy(() => import('./OldApplicants/OldApplicants'));
const LazyInterview = lazy(() => import('./Interview/Interview'));
const LazyTrainingInvites = lazy(() => import('./TrainingInvites/TrainingInvites'));
const LazyInductionInvites = lazy(() => import('./InductionInvites/InductionInvites'));
const LazyReports = lazy(() => import('./Reports/Reports'));



export const AppContext = createContext<any>({});


const Dashboard = (props:any) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const user = useSelector((store:any) => store.user);
  let show:any = true

  const userHasChangePassword = props.data;
  const setUserHasChangePassword = props.onChange;
  let allow_roles = ['Director of membership','Administrator', 'Team Lead'];
  show = allow_roles.find(eRole => eRole.toLowerCase().includes(user.role.toLowerCase()))

  return (
    <div>
          <NavBar/>
          <main className={css.main}>
              <SideBar/>
              <div>
                  <Suspense fallback={<CircularProgress sx={{ fontSize: '1rem', marginInline: 'auto', display: 'block',marginBlock: '2rem' }}/>}>
                    <Routes>
                        <Route index element={<ProtectedRoute><LazyOverview data={{ userHasChangePassword, setUserHasChangePassword }}/></ProtectedRoute>}/>
                        <Route path="/overview/*" element={<ProtectedRoute><LazyOverview data={userHasChangePassword} onChange={setUserHasChangePassword}/></ProtectedRoute>}/>
                        <Route path="/applicants/*"element={<ProtectedRoute><LazyApplicants/></ProtectedRoute>}/>
                        {
                          show ? <Route path="/settings/*" element={<ProtectedRoute><LazySettings/></ProtectedRoute>}/> : <></>
                        }
                        <Route path="/approvals/*" element={<ProtectedRoute><LazyApprovals/></ProtectedRoute>}/>
                        {
                          show ?  <Route path="/payment/*" element={<ProtectedRoute><LazyPayments/></ProtectedRoute>}/> : <></>
                        }
                        <Route path="/payment/*" element={<ProtectedRoute><LazyApplications /></ProtectedRoute>}/>
                        <Route path="/upload-off-line-payment/*" element={<ProtectedRoute><LazyUploadOffLine /></ProtectedRoute>}/>
                        <Route path="/applications/*" element={<ProtectedRoute><LazyApplications /></ProtectedRoute>}/>
                        <Route path="/old-applicants/*" element={<ProtectedRoute><LazyOldApplicants /></ProtectedRoute>}/>
                        <Route path="/interview/*" element={<ProtectedRoute><LazyInterview /></ProtectedRoute>}/>
                        <Route path="/training-invites/*" element={<ProtectedRoute><LazyTrainingInvites /></ProtectedRoute>}/>
                        <Route path="/induction-invites/*" element={<ProtectedRoute><LazyInductionInvites /></ProtectedRoute>}/>
                        <Route path="/reports/*" element={<ProtectedRoute><LazyReports /></ProtectedRoute>}/>

                    </Routes>
                  </Suspense>
              </div>
          </main>
    </div>
  )
}

export default Dashboard